module.exports = __webpack_public_path__ + "5e71f050ba6b3248d148d13d6d8e71ac.jpg";